import React from "react";
import AsciiLogo from "../AsciiLogo";

export default function CliAuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen w-screen bg-blue-500 px-4 py-6 sm:px-6">
      <div className="m-auto w-full max-w-[520px]">
        <div className="pb-2 text-center">
          <AsciiLogo />
        </div>
        <div className="rounded-md bg-zinc-50 px-6 py-7 shadow-lg">
          <div className="text-center">
            <h1 className="m-0 text-[2.3rem] tracking-[0.02em] text-blue-200">Mako</h1>
            <h2 className="mt-1.5 text-[0.95rem] text-blue-100">
              OceanX Mission Data Service
            </h2>
            <p className="mt-2 text-[0.85rem] text-grey-200">CLI Login</p>
          </div>
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
